import { Form, FormInstance, Input } from "antd";
import { useCallback, useMemo } from "react";
import { useCheckAccount } from "../hooks/useCheckAccount";
import _ from "lodash";
import { Rule } from "antd/es/form";
import { FloatNumberInput } from "../../../../../../../../../components/FloatNumberInput";
import { GL_NUMBER_MAX_LENGTH } from "../../../../../../../../../lib/constants";

type AccountInputProps = {
  form: FormInstance;
  isShort: boolean;
  isFormDisabled: boolean;
};

export const AccountInput = ({
  form,
  isShort,
  isFormDisabled,
}: AccountInputProps) => {
  const setFieldError = useCallback(
    (msg: string[]): void => {
      form.setFields([
        {
          name: "accountNumber",
          errors: msg,
        },
      ]);
    },
    [form]
  );

  const { isDisabled, search } = useCheckAccount(form, setFieldError);

  const onEnterClicked = useCallback(
    (event: React.KeyboardEvent<HTMLInputElement>) => {
      const value = +event.currentTarget.value;
      setFieldError([]);

      value && !_.isNaN(value)
        ? search(value)
        : setFieldError(["Please enter correct number"]);
    },
    [search, setFieldError]
  );

  const onInputChange = useCallback(() => {
    setFieldError([]);
    form.setFieldValue("toContractId", null);
  }, [setFieldError, form]);

  const rules = useMemo(() => {
    return [
      () => ({
        validateTrigger: "onSubmit",
        validator(_: Rule, value: string) {
          const toContractId = form.getFieldValue("toContractId");

          if (!value || toContractId) {
            return Promise.resolve("");
          }
          if (value && !toContractId) {
            return Promise.reject(
              new Error("Please press Enter to find the account")
            );
          }
          return Promise.reject(new Error("Account was not found"));
        },
      }),
    ];
  }, [form]);

  const glRules = useMemo(
    () => [
      {
        max: 20,
        message: GL_NUMBER_MAX_LENGTH,
        validateTrigger: "onSubmit",
      },
    ],
    []
  );

  return (
    <>
      {isShort ? (
        <>
          <Form.Item label="Account Number" name="accountNumber" rules={rules}>
            <Input
              disabled={isDisabled || isFormDisabled}
              onPressEnter={onEnterClicked}
              onChange={onInputChange}
            />
          </Form.Item>
          <Form.Item name="toContractId" hidden>
            <Input />
          </Form.Item>
        </>
      ) : (
        <FloatNumberInput
          form={form}
          rules={glRules}
          label="GL/Account Number"
          name="accountNumber"
          prefix=""
        />
      )}
    </>
  );
};
